import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import BackButton from '../BackButton/BackButton';
import Counter    from '../Counter/Counter';

import styles from './Passengers.module.css';

const initialState = {
  adults: 0,
  children: 0,
  infants: 0,
  selected: [],
};

class Passengers extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.savePassengers = this.savePassengers.bind(this);
  }

  clearForm = (e) => {
    e.preventDefault();
    this.setState(initialState);
  }

  savePassengers() {
    const passengerCount = this.state.adults + this.state.children + this.state.infants + this.state.selected.length;
    const passengers = [];
    for (let i = 0; i < passengerCount; i++) {
      passengers.push({
        name: 'passenger'
      });
      
    }
    this.props.setPassengers(passengers);
    //return to previous page
    this.props.history.goBack();
  }

  selectCompany = (e) => {
    let selectedId = e.target.dataset.id;

    if (this.state.selected.indexOf(selectedId) === -1) {
      this.setState({
        selected: [...this.state.selected, selectedId]
      });
    } else {
      let array = [...this.state.selected];
      let index = array.indexOf(selectedId);

      array.splice(index, 1);
      this.setState({ selected: array });
    }
  }

  getData = (data) => {
    this.setState({ [data.label]: data.value });
  }

  render() {
    return (
      <div className={styles.passengerPage}>

        <div className={styles.header}>
          <div className={styles.controls}>
            <BackButton className={styles.back} />
            <Link className={styles.clear} onClick={this.clearForm} to="#" >Clear</Link>
          </div>
          <h2>Select number of passengers</h2>
        </div>

        <div className={styles.count}>
          <div className={styles.row}>
            <label>Adults</label>
            <Counter label={'adults'} sendData={this.getData} value={this.state.adults} />
          </div>
          <div className={styles.row}>
            <label>
              Children
              <span>Ages 2-14</span>
            </label>
            <Counter label={'children'} sendData={this.getData} value={this.state.children} />
          </div>
          <div className={styles.row}>
            <label>
              Infants
              <span>Under 2</span>
            </label>
            <Counter label={'infants'} sendData={this.getData} value={this.state.infants} />
          </div>
        </div>

        <div className={styles.company}>
          <h3>Travelling together again?</h3>

          <div className={styles.row}>
            <img src={require('./img/user-0.png')} alt="" height="50" width="50" />
            <div className={styles.details}>
              <h4>Robert Smith</h4>
            </div>
            <div className={(this.state.selected.includes("1") ? styles.isSelected : '') +' '+ styles.checkbox} data-id="1" onClick={this.selectCompany}></div>
          </div>
          <div className={styles.row}>
            <img src={require('./img/user-1.png')} alt="" height="50" width="50" />
            <div className={styles.details}>
              <h4>Amelia Little</h4>
              <span>AISLE SEAT, PESCATARIAN</span>
            </div>
            <div className={(this.state.selected.includes("2") ? styles.isSelected : '') +' '+ styles.checkbox} data-id="2" onClick={this.selectCompany}></div>
          </div>
          <div className={styles.row}>
            <img src={require('./img/user-2.png')} alt="" height="50" width="50" />
            <div className={styles.details}>
              <h4>John Dobbs</h4>
            </div>
            <div className={(this.state.selected.includes("3") ? styles.isSelected : '') +' '+ styles.checkbox} data-id="3" onClick={this.selectCompany}></div>
          </div>
          <div className={styles.row}>
            <img src={require('./img/user-3.png')} alt="" height="50" width="50" />
            <div className={styles.details}>
              <h4>Jannie Henderson</h4>
              <span>WINDOW SEAT</span>
            </div>
            <div className={(this.state.selected.includes("4") ? styles.isSelected : '') +' '+ styles.checkbox} data-id="4" onClick={this.selectCompany}></div>
          </div>
          <div className={styles.row}>
            <img src={require('./img/user-4.png')} alt="" height="50" width="50" />
            <div className={styles.details}>
              <h4>Shirley Robinson</h4>
            </div>
            <div className={(this.state.selected.includes("5") ? styles.isSelected : '') +' '+ styles.checkbox} data-id="5" onClick={this.selectCompany}></div>
          </div>
        </div>
        <div className={styles.footer} >
          <div onClick={this.savePassengers}>Save</div>
        </div>
      </div>

    );
  }
}

const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setPassengers: data =>
      dispatch({
        type: 'SET_PASSENGERS',
        payload: data,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Passengers);



// WEBPACK FOOTER //
// ./src/components/Passengers/Passengers.jsx